import React from 'react';
import { motion } from 'framer-motion';
import { Star, Reply, MoreVertical, Smile } from 'lucide-react';
interface EmailData {
  id: number;
  name: string;
  email: string;
  time: string;
  relativeTime: string;
  message: string;
  initial: string;
  bgColor: string;
  greeting?: string;
}
const emails: EmailData[] = [{
  id: 1,
  name: 'Alejandro González',
  email: 'ale.gonzalez84@gmail.com',
  time: '5:36 PM',
  relativeTime: '25 minutes ago',
  message: 'Les escribo para avisarles que recibí su guía de resina epóxica y agradecerles porque todo llegó bien y estoy muy conforme con la compra.',
  initial: 'A',
  bgColor: 'bg-slate-200',
  greeting: 'Hola,'
}, {
  id: 2,
  name: 'Mariana Paz',
  email: 'marianapaz_deco@outlook.com',
  time: '10:12 AM',
  relativeTime: '2 hours ago',
  message: 'Ya pude descargar la guía sin problemas. Muy buen contenido, se nota que saben de lo que hablan. Gracias por la atención!',
  initial: 'M',
  bgColor: 'bg-pink-100',
  greeting: 'Buenas,'
}, {
  id: 3,
  name: 'Carlos Rodriguez',
  email: 'carlitos_rod77@yahoo.com.ar',
  time: '2:45 PM',
  relativeTime: '4 hours ago',
  message: 'Todo perfecto, ya tengo el material en mi correo. Excelente material, muy claro el paso a paso. Saludos!',
  initial: 'C',
  bgColor: 'bg-blue-100',
  greeting: 'Estimados,'
}, {
  id: 4,
  name: 'Lucía Fernández',
  email: 'lucia.fer.arq@gmail.com',
  time: '9:20 AM',
  relativeTime: '1 hour ago',
  message: 'Recibido! Muchas gracias por el envío tan rápido. Ya estuve chusmeando un poco y está increíble la info.',
  initial: 'L',
  bgColor: 'bg-purple-100',
  greeting: 'Hola equipo!'
}, {
  id: 5,
  name: 'Juan Manuel Silva',
  email: 'jmsilva_taller@hotmail.com',
  time: '11:55 PM',
  relativeTime: 'Yesterday',
  message: 'Quería confirmar que me llegó el ebook correctamente. Muy conforme con la compra, gracias!',
  initial: 'J',
  bgColor: 'bg-orange-100',
  greeting: 'Buenas noches,'
}, {
  id: 6,
  name: 'Patricia Sosa',
  email: 'pato.sosa.ventas@gmail.com',
  time: '4:30 PM',
  relativeTime: '3 hours ago',
  message: 'Les aviso que ya tengo el libro digital. Todo impecable, gracias por la rapidez en el soporte.',
  initial: 'P',
  bgColor: 'bg-green-100',
  greeting: 'Hola!'
}, {
  id: 7,
  name: 'Roberto Gómez',
  email: 'rober_gomez_pro@outlook.com',
  time: '1:15 PM',
  relativeTime: '5 hours ago',
  message: 'Me llegó el ebook perfecto. Ya lo estoy leyendo y la verdad que vale cada centavo. Gran trabajo!',
  initial: 'R',
  bgColor: 'bg-yellow-100',
  greeting: 'Buen día,'
}, {
  id: 8,
  name: 'Florencia Herrera',
  email: 'flor.herrera.ok@yahoo.com',
  time: '8:40 AM',
  relativeTime: '45 minutes ago',
  message: 'Recibí la guía de resina epóxica. Todo perfecto el acceso, muchas gracias por la buena onda!',
  initial: 'F',
  bgColor: 'bg-teal-100',
  greeting: 'Hola, cómo va?'
}];
function GmailScreenshot({
  email
}: {
  email: EmailData;
}) {
  return <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden text-[#202124] font-sans w-[340px] md:w-[420px] aspect-square flex flex-col flex-shrink-0" data-id="element-102" data-mp="2q4lb4xcwzzsq">
      {/* Header */}
      <div className="p-4 flex items-start gap-3" data-id="element-103" data-mp="2h8c7t7ltgh1b">
        <div className={`w-10 h-10 rounded-full ${email.bgColor} flex items-center justify-center text-gray-600 font-medium text-lg flex-shrink-0`} data-id="element-104" data-mp="2c7y94g63ujfy">
          {email.initial}
        </div>
        <div className="flex-grow min-w-0" data-id="element-105" data-mp="22hwnrw54zf4q">
          <div className="flex flex-wrap items-baseline gap-x-2" data-id="element-106" data-mp="1yfi3d7ltk7bc">
            <span className="font-bold text-[15px] truncate" data-id="element-107" data-mp="1yh2v6pgr1c5i">{email.name}</span>
            <span className="text-gray-500 text-[13px] truncate hidden sm:inline" data-id="element-108" data-mp="1tfdnnjsqjgm6">{`<${email.email}>`}</span>
          </div>
          <div className="flex items-center gap-1 text-gray-500 text-[12px] mt-0.5" data-id="element-109" data-mp="1oi3xu31fp2xt">
            <span data-id="element-110" data-mp="3ok3j06f294cn">To me</span>
            <svg className="w-3 h-3 fill-current" viewBox="0 0 24 24" data-id="element-111" data-mp="3olxteqsphe2h">
              <path d="M7 10l5 5 5-5z" data-id="element-112" data-mp="3ti522rchl3o4" />
            </svg>
          </div>
        </div>
        <div className="flex items-center gap-3 text-gray-400 flex-shrink-0" data-id="element-113" data-mp="3esz394hk9fgr">
          <div className="flex items-center gap-2" data-id="element-114" data-mp="3js3ctw8edf7m">
            <Star className="w-4 h-4" data-id="element-115" data-mp="3jqs7vt37u1ex" />
            <Reply className="w-4 h-4" data-id="element-116" data-mp="35skge0oy7sb5" />
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="px-16 pb-6" data-id="element-117" data-mp="39v73xpel6r2j">
        <p className="text-[15px] mb-4" data-id="element-118" data-mp="39w8n6h5rajvc">{email.greeting || 'Hola,'}</p>
        <p className="text-[15px] leading-relaxed text-gray-800" data-id="element-119" data-mp="2vvpldrrvwa1m">
          {email.message}
        </p>
        <p className="text-[15px] mt-4" data-id="element-120" data-mp="30v25w5va9511">Muchas gracias!</p>
      </div>

      {/* Quick Replies */}
      <div className="px-16 pb-6 flex flex-wrap gap-2" data-id="element-121" data-mp="u4ksyti4n5g8">
        <div className="px-4 py-2 border border-gray-300 rounded-lg text-[13px] font-medium text-gray-700" data-id="element-122" data-mp="z2mc1efjz4rp">
          Nos alegra saberlo!
        </div>
        <div className="px-4 py-2 border border-gray-300 rounded-lg text-[13px] font-medium text-blue-700 bg-blue-50" data-id="element-123" data-mp="2jlgd4nqp7j7f">
          ¡Estamos para ayudarte!
        </div>
      </div>
    </div>;
}
export function EmailSocialProof() {
  return <section className="py-24 bg-[#fdf8f3] relative overflow-hidden flex flex-col items-center pt-[0px] pb-[0px]" data-id="element-124" data-mp="2tcb2i0z8qyx3">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none" data-id="element-125" data-mp="32a4rsryl8sar">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#d97706]/5 rounded-full blur-[120px]" data-id="element-126" data-mp="2xb1rtlxgtc9n" />
      </div>

      <div className="max-w-7xl mx-auto relative z-20 text-center mb-16 px-4" data-id="element-127" data-mp="37aisfoxv0zyr">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-black text-gray-900 mb-6 tracking-tight uppercase" data-id="element-128" data-mp="378eqhcjiub14">
          ¡EL IMPACTO ES{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d97706] to-[#92400e]" data-id="element-129" data-mp="26mh69zvfqf7v">
            TOTAL!
          </span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-gray-400 text-xl max-w-2xl mx-auto font-medium" data-id="element-130" data-mp="2gkod3pw0fgw5">
          Cientos de personas ya están transformando su realidad con nuestro
          material.
        </motion.p>
      </div>

      {/* Marquee Carousel */}
      <div className="relative w-full overflow-hidden py-10 [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]" data-id="element-131" data-mp="34bal5h60l165">
        <motion.div className="flex gap-8 w-max" animate={{
        x: [0, -2000] // Increased distance for smoother loop with more items
      }} transition={{
        duration: 25,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-132" data-mp="xl77se2kv54e">
          {/* Triple emails for a truly seamless long loop */}
          {[...emails, ...emails, ...emails].map((email, index) => <div key={`${email.id}-${index}`} className="flex-shrink-0 hover:scale-105 transition-transform duration-300" data-id="element-133" data-mp="1ganan81qj9nz" data-mpi={index}>
              <GmailScreenshot email={email} data-id="element-134" data-mp="16ln7rdk43u4i" />
            </div>)}
        </motion.div>
      </div>

      {/* Bottom CTA */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.5
    }} className="mt-16 relative z-30 px-4" data-id="element-135" data-mp="11mann0kml15m">
        <div className="bg-white border border-[#d97706]/30 px-8 py-4 rounded-full text-[#d97706] font-bold text-lg shadow-[0_0_30px_rgba(217,119,6,0.1)] animate-pulse" data-id="element-136" data-mp="12n3nu0wo4uny">
          +2,500 CORREOS DE AGRADECIMIENTO RECIBIDOS
        </div>
      </motion.div>
    </section>;
}